<!-- 产品属性 -->
<template>
    <div v-if="componentsData.type == 13">
        <div class="overflow-hidden"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <div class="fw-bold"
                :style="`
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                    padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px 6px ${componentsData.content.marginData.left}px;
                `"
            >
                产品属性
            </div>
            <div
                :style="`
                    background: ${componentsData.content.text_bg_color}; font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};
                    padding: 0 ${componentsData.content.marginData.left}px ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;
                `"
            >
                <div class="pt-6">属性字段：xxx</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
}
.pt-6 {
    padding: 6px 0 0 0;
}
</style>